module.exports = __webpack_public_path__ + "img/marker-point-verde.92f18f2e.png";